import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    height: "50%"
  },
  aktiverMesspunktColumn: {
    borderRight: `1px solid ${
      theme.palette.type === 'light' ? '#f0f0f0' : '#303030'
    }`,
  },
  columnMinWith: {
    minWidth: "5vw"
  },
  columnComment: {
    minWidth: "7vw",
    maxWidth: "25vw",
    whiteSpace: "pre-wrap",
  },
  datePicker: {
    minWidth: "100%",
    marginTop: theme.spacing(2),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: "10px",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
      paddingTop: "5px",
    },
  },
  numberField: {
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none"
    }
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginTop: "10px", 
    marginBottom: "10px",
  },
  formControlAutoComplete: {
    margin: "10px"
},
formControl: {
    minWidth: "60%",
    margin: "10px",
},
input: {
    padding: "5px",
},
centerTypographyRoot: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "top"
},
  paddingPaper:{
    paddingBottom: theme.spacing(2),
    minHeight:"100%",
    height:"100%"
},
}), {index: 1});
